import { Button, Icon } from "@simplybusiness/mobius";
import classNames from "classnames/dedupe";
import { chevronLeft, chevronRight } from "@simplybusiness/icons";

export type ScrollDirection = "left" | "right";

type ScrollButtonProps = {
  onClick: (direction: ScrollDirection) => void;
  direction: ScrollDirection;
  isHidden?: boolean;
};

export const ScrollButton = ({
  onClick,
  direction,
  isHidden = false,
}: ScrollButtonProps) => {
  const scrollButtonClasses = classNames(
    "mobius-chatbot-prompts__scroll-button",
    {
      "mobius-chatbot-prompts__scroll-button--left": direction === "left",
      "mobius-chatbot-prompts__scroll-button--right": direction === "right",
      "mobius-chatbot-prompts__scroll-button--hidden": isHidden,
    },
  );

  return (
    <Button
      className={scrollButtonClasses}
      onClick={() => onClick(direction)}
      isDisabled={isHidden}
      variant="basic"
      aria-label={`Scroll prompts ${direction}`}
    >
      <Icon
        icon={direction === "left" ? chevronLeft : chevronRight}
        size="sm"
        title={`Scroll prompts ${direction}`}
      />
    </Button>
  );
};
